import clsx from 'clsx'

import BrandMark from './BrandMark'
import Wordmark from './Wordmark'

const MARK_SIZES = {
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl'
}

function BrandLockup({ size = 'md', inverse = false, className = '' }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-2.5 whitespace-nowrap',
        inverse ? 'text-white' : 'text-[var(--x3-text)]',
        className
      )}
    >
      <BrandMark size={MARK_SIZES[size] || 'md'} className="shrink-0" />
      <Wordmark size={size} inverse={inverse} />
    </span>
  )
}

export default BrandLockup
